<template>
  <v-row justify="center">
    <v-dialog v-model="active" :persistent="true" max-width="500">
      <v-card class="pa-3">
        <div class="close-dialog-btn mt-2" style="top: 22px">
          <v-icon color="#D8DDE4" @click="close">mdi-close</v-icon>
        </div>
        <v-card-title class="text-h5 my-1" style="font-weight:800">
          <span>{{$t('__import')}}</span>
        </v-card-title>
        <v-card-text class="text-left" style="font-weight:600; font-size:15px">
          <h4>{{$t('__importHint')}}</h4>
        </v-card-text>
        <v-row class="ma-0 pb-2 Import">
          <v-col class="pa-0 col-12 px-6">
            <v-file-input :placeholder="$t('__selectImportFile')"
            outlined dense background-color="white"
            class="file" ref="uploader" prepend-icon=""
            accept=".xlsx" v-model="uploadFile">
              <template v-slot:append>
                <div style="width:90px; background:#ED6D00; color:white; text-align:center; cursor:pointer" @click.stop="$refs.uploader.$el.querySelector('input').click()">
                  {{$t('__chooseFile')}}
                </div>
              </template>
            </v-file-input>
          </v-col>
        </v-row>
        <v-row class="pt-1 pb-2" justify="center">
          <v-card-actions>
            <VueLoadingButton class="colorBtn" style="width: 180px"
              @click.native="downloadExample()">
              <span style="color:#FFFFFF; font-size: 0.875rem">{{$t('__downloadSample')}}</span>
            </VueLoadingButton>
          </v-card-actions>
          <v-card-actions>
            <VueLoadingButton class="colorBtn" style="width: 180px"
              :style="{'background': uploadFile ? '#ED6D00' : '#979491'}"
              @click.native="importExcel" :loading="isUploadingTrackFile"
            >
              <span style="color:#FFFFFF; font-size: 0.875rem">{{$t('__confirmImport')}}</span>
            </VueLoadingButton>
          </v-card-actions>
        </v-row>
      </v-card>
    </v-dialog>
    <ShowMsg ref="ShowMsg"/>
    
    <!-- Import Result Dialog -->
    <v-dialog v-model="showImportResult" max-width="500" persistent>
      <v-card class="pa-3">
        <!-- <div class="close-dialog-btn mt-2" style="top: 22px">
          <v-icon color="#D8DDE4" @click="close">mdi-close</v-icon>
        </div> -->
        <v-card-title class="text-h5 my-1" style="font-weight:800">
          {{ $t('__importResultTitle') }}
        </v-card-title>
        <v-card-text class="text-left mt-1" style="font-weight:600; font-size:15px">
          {{ importResultMessage }}
          <div v-if="importResultData && importResultData.errors && importResultData.errors.length > 0" class="mt-3">
            <div style="color:#ED6D00; margin-bottom:4px;">{{ $t('__importErrors') }}</div>
            <div v-for="(err, idx) in importResultData.errors" :key="idx" style="color:#b71c1c; font-size:13px;">{{ err }}</div>
          </div>
        </v-card-text>
        <v-row justify="center">
          <v-card-actions class="mb-2 px-3" style="justify-content:center">
            <v-btn class="colorBtn primary-color-background" outlined color="#FFF" @click="showImportResult = false; save();">
              {{ $t('__confirm') }}
            </v-btn>
          </v-card-actions>
        </v-row>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import i18n from '@/plugins/i18n'
import VueLoadingButton from 'vue-loading-button';
import ShowMsg from '@/dialogs/ShowMsg'

export default {
  components: {VueLoadingButton,ShowMsg},
  name:'ImportFile',
  props:['onSave'],
  data () {
    return {
      active: false,
      uploadFile: null, // 存放上傳的檔案
      parsedData: [], // 存放解析後的資料
      useType:'',
      importInfo:{},
      onSaveEn: false,
      isLoading: false,

      isUploadingTrackFile: false,
      // Excel import result
      showImportResult: false,
      importResultMessage: '',
      importResultData: null,
    }
  },
  methods:{
    open(data, onSaveEn = false){
      this.active = true
      this.useType = data
      this.onSaveEn = onSaveEn
    },
    close(){
      this.active = false
    },
    save(){
      if(this.onSaveEn){
        this.onSave()
      }
      this.close()
    },

    downloadExample(){
      const map = {
        maintenance: {
          url: '/file/common/download?name=demo/downloadMaintenance.xlsx',
          name: 'downloadMaintenance.xlsx'
        },
        device: {
          url: '/file/common/download?name=demo/downloadDevice.xlsx',
          name: 'downloadDevice.xlsx'
        },
        organization: {
          url: '/file/common/download?name=demo/downloadOrganization.xlsx',
          name: 'downloadOrganization.xlsx'
        },
        staff: {
          url: '/file/common/download?name=demo/downloadEmployee.xlsx',
          name: 'downloadEmployee.xlsx'
        },
      }

      const config = map[this.useType]
      if (!config) return

      this.$http({
        method: 'GET',
        url: config.url,
        responseType: 'arraybuffer'
      }).then((response) => {
        const blob = new Blob([response.data], { type: 'application/vnd.ms-excel' })
        const link = document.createElement('a')

        link.href = window.URL.createObjectURL(blob)
        link.download = config.name
        link.click()
      })
    },

    importExcel() {
      if (!this.uploadFile) {
        this.$refs.ShowMsg.open(0, i18n.t('__noFileSelected'), i18n.t('__pleaseSelectFile'))
        return
      }

      const map = {
        maintenance: {
          url: '/ImportMaintenanceExcel'
        },
        device: {
          url: '/ImportDeviceExcel'
        },
        organization: {
          url: '/ImportOrganizationExcel'
        },
        staff: {
          url: '/ImportEmployeeExcel'
        },
      }

      const config = map[this.useType]
      if (!config) return

      // v-file-input 可能是 File 或 Array
      const file = Array.isArray(this.uploadFile)
        ? this.uploadFile[0]
        : this.uploadFile
      const formData = new FormData()
      formData.append('file', file)
      this.isUploadingTrackFile = true
      this.$http({
        method: 'POST',
        url: config.url,
        params: { lang: this.language },
        headers: { 'Content-Type': 'multipart/form-data' },
        data: formData
      })
      .then((response) => {
        const res = response.data

        this.importResultMessage =
          (res.State === '9884')
            ? this.$t('__serialNumberExists')
            : (res.Message || '')

        this.importResultData = res.Data || null
        this.showImportResult = true
      })
      .catch((error) => {
        const errorMsg = error.response?.data?.Message || (i18n.t('__importFailed'))
        this.$refs.ShowMsg.open(0, this.$t('__error'), errorMsg)
      })
      .finally(() => {
        this.isUploadingTrackFile = false
        this.uploadFile = null // 清掉選擇（重要）
      })
    },
  }
}
</script>